import * as React from "react";
import { RequestSorting } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { SortingChangeHandler, SortingOption } from "../types";
import deepEqual from "fast-deep-equal";

type SortingTabProps = SortingOption & {
  href: string;
  onSort: SortingChangeHandler;
  active: boolean;
};

export type SortTabsProps = {
  sortingOptions: SortingOption[];
  onSort: SortingChangeHandler;
  makeLink?: (sorting: RequestSorting) => string;
  activeSorting: RequestSorting;
};

const SortingTab = ({
  title,
  href,
  requestSorting,
  onSort,
  active,
}: SortingTabProps): JSX.Element => (
  <li>
    <a
      className={active ? "active" : undefined}
      href={href}
      onClick={(event) => {
        event.preventDefault();
        onSort(requestSorting);
      }}
    >
      {title}
    </a>
  </li>
);

const sortingKey = (sorting: RequestSorting): string =>
  Object.values(sorting).join("_");

export const SortingTabs = ({
  sortingOptions,
  makeLink = (sorting) => `./?sort=${sortingKey(sorting)}`,
  activeSorting,
  onSort,
}: SortTabsProps): JSX.Element => (
  <div className="category-options-wrapper">
    <div className="sortable-tabs">
      <ul className="sortable_tabs" id="search-results">
        {sortingOptions.map((sortingOption) => (
          <SortingTab
            {...sortingOption}
            active={deepEqual(sortingOption.requestSorting, activeSorting)}
            href={makeLink(sortingOption.requestSorting)}
            onSort={onSort}
            key={sortingKey(sortingOption.requestSorting)}
          />
        ))}
      </ul>
      <div id="sortable_delimiter_line" />
    </div>
  </div>
);
